<template>
  <v-list
    dense
    outlined
    color="secondary"
  >
    <v-list-item>
      <v-list-item-title class="primary--text">
        Consejo de Honor y Justicia
      </v-list-item-title>
      <v-list-item-icon class="primary--text justify-center font-weight-bold">
        {{ getRandomNumber(15) }}
      </v-list-item-icon>
    </v-list-item>
    <v-divider />
    <v-list-item>
      <v-list-item-title class="primary--text">
        Asuntos internos
      </v-list-item-title>
      <v-list-item-icon class="primary--text justify-center font-weight-bold">
        {{ getRandomNumber(15) }}
      </v-list-item-icon>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  methods: {
    getRandomNumber(max) {
      return Math.floor(Math.random() * max);
    },
  },
};
</script>
